import { HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { GbApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-api.service'
import { Observable } from 'rxjs'
import { RaffleDrawsEntity, RaffleItemsEntity } from './raffles.models'
import { ItemTypeEnum } from '@galabid/gb-dashboard/item/data-access'
import { GbPaginatedResponse } from '@galabid/gb-dashboard/core/data-access'
import { ItemsEntity } from 'libs/gb-dashboard/item/data-access-selected-item/src/lib/+state/selected-item.models'

@Injectable({
  providedIn: 'root',
})
export class RafflesApiService extends GbApiService {
  getRaffleItems(
    urlName: string,
    limit: number,
    offset: number,
    ordering?: string,
  ): Observable<GbPaginatedResponse<ItemsEntity>> {
    let params = new HttpParams()
      .set('expand', true)
      .set('item_type', ItemTypeEnum.Raffle)
      .set('limit', limit)
      .set('offset', offset)
    if (ordering) {
      params = params.set('order', ordering)
    }
    return this.get<GbPaginatedResponse<ItemsEntity>>(`auctions/${urlName}/items/`, { params })
  }

  getRaffleItem(urlName: string, uuid: string): Observable<ItemsEntity> {
    const url = `auctions/${urlName}/items/${uuid}/`
    const params = new HttpParams().set('expand', 'true')
    return this.get<ItemsEntity>(url, { params })
  }

  updateRaffleItem(
    urlName: string,
    uuid: string,
    raffleItem: Partial<RaffleItemsEntity>,
  ): Observable<RaffleItemsEntity> {
    const url = `auctions/${urlName}/raffle-items/${uuid}/`
    return this.patch<RaffleItemsEntity>(url, raffleItem)
  }

  concludeRaffle(urlName: string, uuid: string, sendNotifications: boolean) {
    const url = `auctions/${urlName}/raffle-items/${uuid}/close-raffle/`
    return this.post<void>(url, { send_notifications: sendNotifications })
  }

  getRaffleDraws(
    urlName: string,
    itemUuid: string,
    offset: number,
    limit: number,
  ): Observable<GbPaginatedResponse<RaffleDrawsEntity>> {
    const params = new HttpParams()
      .set('raffle_item', itemUuid)
      .set('offset', offset.toString())
      .set('limit', limit.toString())

    return this.get<GbPaginatedResponse<RaffleDrawsEntity>>(`auctions/${urlName}/raffle-draws/`, { params })
  }

  drawRaffle(urlName: string, item: string, raffleItem: string, prize: number): Observable<RaffleDrawsEntity> {
    const url = `auctions/${urlName}/raffle-draws/`
    return this.post<RaffleDrawsEntity>(url, { auction: urlName, item, raffle_item: raffleItem, prize })
  }

  bulkDrawRaffle(urlName: string, raffleItem: string): Observable<RaffleDrawsEntity[]> {
    const url = `auctions/${urlName}/raffle-draws/bulk-draw/`
    return this.post<RaffleDrawsEntity[]>(url, { raffle_item: raffleItem }, this.skipPusherOptions)
  }

  redrawRaffle(urlName: string, raffleDraw: RaffleDrawsEntity): Observable<RaffleDrawsEntity> {
    const url = `auctions/${urlName}/raffle-draws/${raffleDraw.uuid}/redraw/`
    return this.post<RaffleDrawsEntity>(url, raffleDraw)
  }

  deleteRaffleDraw(urlName: string, uuid: string): Observable<void> {
    const url = `auctions/${urlName}/raffle-draws/${uuid}/`
    return this.delete<void>(url)
  }
}
